import React from 'react';

import cn from 'classnames';

import IconFemtasy from 'components/IconFemtasy';

import { usePlayer } from 'hooks/usePlayer';

import './style.scss';

interface IProps {
  children: React.ReactNode;
  onClose: () => void;
  showBanner: boolean | undefined;
  withTabBar?: boolean;
}

const Banner = ({ children, onClose, showBanner, withTabBar }: IProps) => {
  const { currentlyPlaying } = usePlayer();
  const { isFullPlayer } = usePlayer();

  return (
    <div
      onClick={() => onClose()}
      className={cn(
        'PromoBanner',
        { PromoBanner__withTabBar: withTabBar },
        { PromoBanner__withMiniPlayer: currentlyPlaying },
        { PromoBanner__withFullPlayer: isFullPlayer },
        { PromoBanner__shown: showBanner },
        { PromoBanner__hidden: showBanner !== undefined && !showBanner },
      )}
      data-testid="banner-test"
    >
      <div className="PromoBanner__wrapper">
        <div className="PromoBanner__text">{children}</div>
        <div aria-label="Close banner" className="PromoBanner__closeIcon">
          <IconFemtasy icon="Cancel" />
        </div>
      </div>
    </div>
  );
};

export default Banner;
